import { AlertCircle, Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

interface DataStateMessageProps {
  loading?: boolean;
  /** Chuỗi hiển thị khi rỗng. `null` = không rỗng, không render gì. */
  empty?: string | null;
  emptyHint?: string;
  emptyIcon?: ReactNode;
}

/** Trạng thái "đang tải" / "không có dữ liệu" cho bảng và danh sách. */
export function DataStateMessage({
  loading = false,
  empty = null,
  emptyHint,
  emptyIcon,
}: DataStateMessageProps) {
  if (loading) {
    return (
      <div className="text-ink-dim flex items-center justify-center gap-2 px-4 py-12 text-[12px] font-medium">
        <Loader2 size={14} className="animate-spin" />
        Đang tải...
      </div>
    );
  }

  if (empty) {
    return (
      <div className="text-ink-ghost flex flex-col items-center gap-2 px-5 py-12">
        {emptyIcon ?? <AlertCircle size={32} className="text-line" />}
        <p className="text-ink-faint text-[14px] font-semibold">{empty}</p>
        {emptyHint && <span className="text-ink-ghost text-[12px]">{emptyHint}</span>}
      </div>
    );
  }

  return null;
}
